import {
  useAddProfileInRequirement,
  useAddProfileSpacInProfCourse,
  useAddProfilesSpacWithValidCourse,
  useAddProfilesWithValideCourse,
  useGetMode,
} from './index';

function useCustomHookTest(useSPAC: any) {
  const edit = useGetMode();
  const addProfileSpacInProfCourse = useAddProfileSpacInProfCourse();
  const addProfileInRequirement = useAddProfileInRequirement();
  const addProfilesSpacWithValidCourse = useAddProfilesSpacWithValidCourse();
  const addProfilesWithValideCourse = useAddProfilesWithValideCourse();

  if (useSPAC) {
    if (edit) {
      return addProfilesSpacWithValidCourse;
    }
    return addProfileSpacInProfCourse;
  }

  if (edit) {
    return addProfilesWithValideCourse;
  }

  return addProfileInRequirement;
}

export default useCustomHookTest;
